import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import { GetPropertyReport, ImageUpload, UploadPropertyReturnsDocument } from "../../Repository/Api";
import { imagepath } from "../../Repository/BaseUrl";
import { NonEmptyValidation } from "../../Store/validate";
import { errorMsg, successMsg } from "../Toastify";
const StaffPropertyReportUpload = () => {
  const { first_name, desingation, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const navigate = useNavigate();
  const [apply, setApply] = useState({});
  const [word, setWord] = useState('');
  const [pdfName, setPdfName] = useState('');
  const [validation, setValidation] = useState({})
  

  useEffect(() => {
    getDownloadreport()
  },[]);
  const FinancialYearOptions = () => {
    const date = new Date()
    const isApril = date.getMonth() >= 3
    const currentYear1 = date.getFullYear();
    const currentYear = currentYear1 + 1;
    const startYear = 2024;
    const numberOfYears = currentYear - 2024
    const dummyyearOptions = [];
    for (let i = 0; i < numberOfYears; i++) {
      dummyyearOptions.push(startYear + i);
    }
    const yearOptions = dummyyearOptions.map((item) => ({
      label: `${item}-${item + 1}`,
      value: `${item}-${item + 1}`
    }));

    const finalData = isApril ? yearOptions : yearOptions?.pop()
    // return finalData
    return yearOptions
  }
  const setData = (e, key) => {
    setApply({ ...apply, [key]: e });
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };

  const UploadDocument = async (e, key) => {
    const file = e?.target?.files[0];
    
    const maxSizeInBytes = 2 * 1024 * 1024;
    if (file?.size > maxSizeInBytes) {
      errorMsg("File size exceeds the limit of 2MB");
      return;
    }
    if (file && file.type === 'application/pdf') {
      let formData = new FormData();
      let str = file?.name;
      setPdfName(str)
      formData.append("file", file);
      formData.append("fileName", moment().format("YYYYMMDDHHmmss") + "_" + str);
      formData.append("file_path", "/employee_property_returns");
      

      const response = await ImageUpload(formData);
      if (response && response?.statusCode === 200) {
        setData(response?.data, key);
        successMsg(response?.message);
      }
      else {
        errorMsg(response?.message);
      }
    } else {
      errorMsg('Upload pdf file only')
    }
  };

  const handleSubmit = async () => {

    const validate = {}
    validate.academic_year = NonEmptyValidation(apply?.academic_year)
    validate.document_url = NonEmptyValidation(apply?.document_url)
    setValidation(validate)
    if (Object.values(validate).every((v) => v.status === true)) {
      const response = await UploadPropertyReturnsDocument(apply, token)
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        navigate(-1)
      } else {
        errorMsg(response.message);
      }
    }
  }
  
  const getDownloadreport = async () => {
    const response = await GetPropertyReport(token)
    if (response && response.statusCode === 200) {
      setWord(response?.data)
    } else {
      errorMsg(response.message);
    }
  }
  
  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">
                  {first_name} - {desingation}
                </h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
              <div className="col-lg-6">
                <div className="text-center headeralign">
                  <a href={`${imagepath + word}`} download='PropertyReturnsDocument' target="_blank">
                    <button
                      className="requestbtn"
                    >
                      Download Document
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <h6 className="labeltitle"> <span
                  className="arrowicon"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  ← &nbsp;
                </span>Property Returns Report</h6>
                <div className="row mt-3 align-items-end">
                  <div className="col-lg-4">
                    <label className="labeltext"> Academic Year *</label>
                    <ReactSelect
                      isMulti={false}
                      value={{
                        label: apply.academic_year,
                        value: apply.academic_year,
                      }}
                      onChange={(selectedOption) =>
                        setData(selectedOption.value, "academic_year")
                      }
                      options={FinancialYearOptions()}
                    />
                    <small className="validationerror">
                      {validation?.academic_year?.message
                        ? `Academic Year ${validation?.academic_year?.message}`
                        : ""}
                    </small>
                  </div>

                  <div className="col-lg-8 p-0 d-flex flex-column">
                    <small>Max. file upload 200kb</small>
                    <div className="me-4 d-flex">

                      <input
                        type="file"
                        className="d-none"
                        id="propertyUploadBtn"
                        accept="application/pdf"
                        onChange={(e) =>
                          UploadDocument(e, "document_url")
                        }
                      />
                      <label
                        for="propertyUploadBtn"
                        className="requestbtn">
                        Upload Document
                      </label>
                      {apply?.document_url ?
                        <div className="d-flex align-items-center">
                          <a className="ms-3" href={`${imagepath + apply?.document_url}`} target="_blank">
                            <button className="requestbtn" >View</button>
                          </a> <p className="mb-0 ms-3">{pdfName}</p></div> : ""}
                    </div>

                    <div>
                      <small className="validationerror">
                        {validation?.document_url?.message
                          ? `File ${validation?.document_url?.message}`
                          : ""}
                      </small>
                    </div>
                  </div>
                </div>
                <div className="mt-4 text-center">
                  <button
                    className="requestbtn"
                    onClick={handleSubmit}
                  >Submit</button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default StaffPropertyReportUpload;
